<template>
<div class="wrapper">
  <CRow class="mt-3">
    <CCol sm="5" lg="4" >
        <CCard>   
            <CButton
          @click="cardCollapse = !cardCollapse"
          tag="button"
          color="link" 
          block
          class="text-left shadow-none card-header"
        > 
          <b class="m-0">iCare Info</b>
          <b-iconstack  class="float-right mt-1" font-scale="1" rotate="90">
            <b-icon  v-show="cardCollapse" icon="chevron-right" variant="primary"></b-icon>
            <b-icon   v-show="!cardCollapse" class="float-right mt-1" font-scale="1" rotate="0" icon="chevron-left" variant="primary"></b-icon>

          </b-iconstack>
         
         
              </CButton>
              <CCollapse :show="!cardCollapse">
              <CCardBody>
                    
              <p  > <b>iCare Name </b> <br>  {{ response.data.name }}  </p>
              <p class="mt-3" > <b> Description</b> <br> <span style="white-space: pre">{{ response.data.description }} </span></p>
              <p class="mt-3" > <b> City  </b> <br>  {{ response.data.city }}  </p>
              <p class="mt-3" > <b> State </b> <br>  {{ response.data.state }} </p>
              <p class="mt-3" > <b> Zone </b> <br>  {{ response.data.zone ? response.data.zone.name : '-' }} </p>
              <p class="mt-3" > <b> Lokasi </b> <br>  {{ response.data.location ? response.data.location.name : '-' }} </p>
              <p class="mt-3" > <b> Kategori </b> <br>  {{ response.data.category ? response.data.category.name : '-' }} </p>
              <p class="mt-3" > <b> Hari &amp; Jam </b> <br>  {{ response.data.meeting_day ? response.data.meeting_day + ' ' + response.data.meeting_time : '-' }} </p>
              <p class="mt-3" > <b> Range Usia </b> <br>  {{ response.data.age_ranges && response.data.age_ranges.length ? response.data.age_ranges.map(r => r.label).join(', ') : '-' }} </p>
              <hr>
            <b><p class="mt-3" > ICARE LEADER  </p>  </b>
           
            
            <CRow>
              <CCol   >
          {{ leader.firstname + ' ' + leader.lastname}} 
              </CCol>
              <CCol >
          <CButton  block variant="outline" color="danger" size="sm" v-if="leader.id" @click="remove_leader(response.data.id, leader.id)">  Remove as Leader </CButton> 
              </CCol>
            </CRow>
           <hr>
        

              <b> <p class="mt-3" > CORE TEAM  </p> </b>
              <p href="#" v-for="item in response.data.icare_core_team" :key="item.id">  
            
            <CRow>
              <CCol   >
         {{ item.member.firstname + ' ' + item.member.lastname}} 
     
              </CCol>
              <CCol >
          <CButton  block  variant="outline" color="danger" size="sm" @click="remove_core_team(response.data.id, item.member.uuid)">Remove as Core Team</CButton>
              </CCol>
            </CRow>
        
        </p>   
                  </CCardBody>
              </CCollapse>
          </CCard>

        <CCard>   
            <CButton 
                block 
                color="link" 
                class="text-left shadow-none card-header" 
                @click="accordion = accordion === 1 ? false : 1" 
              >
                <b class="m-0">iCare Note</b>
                <b-iconstack  class="float-right mt-1" font-scale="1" rotate="90">
            <b-icon  v-show="accordion === 1 ? false : 1" icon="chevron-right" variant="primary"></b-icon>
            <b-icon   v-show="accordion === 1  " class="float-right mt-1" font-scale="1" rotate="0" icon="chevron-left" variant="primary"></b-icon>

          </b-iconstack>
              </CButton>
              <CCollapse :show="accordion === 1">
              <CCardBody>
                        <CButton  variant="outline" color="info" @click="openModalNewNote()">Add New iCare Note</CButton>

                    <div>
                      <CCard  v-for="item in response.data.icare_note" :key="item.id">
                        <CButton 
                          block 
                          color="link" 
                          class="text-left shadow-none card-header" 
                          @click="accordion = accordion === `${item.id}` ? false : `${item.id}`" 
                        >
                          <h6>{{ item.subject }}</h6>
                          
                        </CButton>
                        <CCollapse :show="accordion === `${item.id}`">
                          <CCardBody>
                          <p> <strong> Subject </strong> :  {{ item.subject }} </p>
                          <p> <strong> Content </strong> :  {{ item.content }} </p>
                           
                            <br><br><CButton @click="openModalEditNote(item.id)" color="primary" size="sm"><b-icon icon="pencil"></b-icon></CButton>
                            <CButton class="ml-2" @click="destroyNote(item.id)" color="danger" size="sm"><b-icon icon="trash"></b-icon></CButton>
                          </CCardBody>
                        </CCollapse>
                      </CCard>
                    </div>
                  </CCardBody>
              </CCollapse>
          </CCard>

          <CCard>   
            <CButton 
                block 
                color="link" 
                class="text-left shadow-none card-header" 
                @click="accordion = accordion === 2 ? false : 2" 
              >
                <b class="m-0">iCare Meeting</b>
                <b-iconstack  class="float-right mt-1" font-scale="1" rotate="90">
            <b-icon  v-show="accordion === 2 ? false : 2" icon="chevron-right" variant="primary"></b-icon>
            <b-icon   v-show="accordion === 2  " class="float-right mt-1" font-scale="1" rotate="0" icon="chevron-left" variant="primary"></b-icon>

          </b-iconstack>
              </CButton>
              <CCollapse :show="accordion === 2">

              <CCardBody>
                 <CButton  variant="outline" color="info" @click="openModalMeeting()">Add New iCare Meeting</CButton>

                  <div>
                    <CCard  v-for="item in response.data.icare_meeting" :key="item.id">
                      <CButton 
                        block 
                        color="link" 
                        class="text-left shadow-none card-header" 
                        @click="accordion = accordion === `${item.id}` ? false : `${item.id}`" 
                      >
                        <h6>{{ item.subject }}</h6>
                        
                      </CButton>
                      <CCollapse :show="accordion === `${item.id}`">
                        <CCardBody>
                        <p> <strong> Description </strong> :  {{ item.description }} </p>
                        <p> <strong> Location </strong> :  {{ item.location }} </p>
                        <p> <strong> Start Time </strong> :  {{ item.start_time }}  </p>
                        <p> <strong> End Time </strong> :  {{ item.end_time }}  </p>
                          
                          <br><br><CButton @click="openModalEditMeeting(item.id)" color="primary" size="sm"><b-icon icon="pencil"></b-icon></CButton>
                          <CButton class="ml-2" @click="destroyMeeting(item.id)" color="danger" size="sm"><b-icon icon="trash"></b-icon></CButton>
                        </CCardBody>
                      </CCollapse>
                    </CCard>
                  </div>
                </CCardBody>
              </CCollapse>
          </CCard>

        <CCard>   
          <CButton 
                block 
                color="link" 
                class="text-left shadow-none card-header" 
                @click="accordion = accordion === 3 ? false : 3" 
              >
                <b class="m-0">Tools</b>
                <b-iconstack  class="float-right mt-1" font-scale="1" rotate="90">
            <b-icon  v-show="accordion === 3 ? false : 3" icon="chevron-right" variant="primary"></b-icon>
            <b-icon   v-show="accordion === 3  " class="float-right mt-1" font-scale="1" rotate="0" icon="chevron-left" variant="primary"></b-icon>

          </b-iconstack>
              </CButton>
              
              <CCollapse :show="accordion === 3">
          <CListGroup >
            <CListGroupItem>  
              <div>
                <CRow>
                  <CCol>
                    Background Image
                  </CCol>
                  <CCol >
                    <CButton  class="ml-4"  variant="outline" color="danger" size="sm" @click="openShowPhoto(response.data.image)">Show</CButton>
                    <CButton  class="ml-4"  variant="outline" color="danger" size="sm" @click="openModalPhoto(response.data.id)">Upload</CButton>
                  </CCol>
                </CRow>
              </div>
            </CListGroupItem>      
          </CListGroup>
        </CCollapse>
        </CCard>

        <!-- <CCard>   
    <CCardHeader><b>Core Team</b></CCardHeader>
      <CListGroup >
        <CListGroupItem href="#" v-for="item in response.data.icare_core_team" :key="item.id">  
          <div>
            <CRow>
              <CCol   >
          {{ item.member.firstname + ' ' + item.member.lastname}} 
              </CCol>
              <CCol >
          <CButton  class="ml-4"  variant="outline" color="danger" size="sm" @click="remove_core_team(response.data.id, item.member.uuid)">Remove as Core Team</CButton>
              </CCol>
            </CRow>
          </div>
        </CListGroupItem>      
      </CListGroup>
    </CCard> -->
         
      
    </CCol>
    
    <CCol sm="5" lg="8" > 
      <CCard>   
    <CButton 
                block 
                color="link" 
                class="text-left shadow-none card-header" 
                @click="accordion = accordion === 4 ? false : 4" 
              >
                <b class="m-0">New Visitor</b>
                <b-iconstack  class="float-right mt-1" font-scale="1" rotate="90">
            <b-icon  v-show="accordion === 4 ? false : 4" icon="chevron-right" variant="primary"></b-icon>
            <b-icon   v-show="accordion === 4  " class="float-right mt-1" font-scale="1"  rotate="0" icon="chevron-left" variant="primary"></b-icon>

          </b-iconstack>
              </CButton>
              <CCollapse :show="accordion === 4">
      <CListGroup >
        <CListGroupItem v-for="item in response.data.icare_visitor " :key="item.id">
        <div>
        <CRow>
          <CCol>
          {{ item.visitor.firstname + ' ' + item.visitor.lastname}}
          </CCol>
        </CRow>
        </div>
        </CListGroupItem>  
         </CListGroup>
      </CCollapse>
    </CCard>
    <CCard>   
    <CCardHeader><b>Total Members</b></CCardHeader>
     <CListGroup v-for="item in response.data.member" :key="item.id">
        <CListGroupItem href="#">  
          <CRow>
            <CCol  @click="show_member(item.uuid)" >
          <img  class="c-avatar-img mr-4 mt-2" v-bind:src="getPhoto(item.get_photo)" >{{ item.firstname + ' ' + item.lastname}} 
          <CBadge color="primary" v-if="item.uuid == leader.id"> <b> LEADER </b> </CBadge>
          <CBadge color="primary" v-if="icare_core_team_id.includes(item.uuid)"> <b> CORE TEAM </b> </CBadge>
          <br>
          
            </CCol>
            <CCol class="col-4">
          <CButton block variant="outline" color="info"
          size="sm"  v-if="!icare_core_team_id.includes(item.uuid) && item.uuid != leader.id "
          @click="assign_core_team(response.data.id, item.uuid)">Assign as Core Team
          </CButton>
          <CButton class="mt-2"  variant="outline" color="success" block size="sm" v-if="!leader.id  " @click="assign_leader(response.data.id, item.uuid)">Assign As Leader</CButton>
          <CButton block class="mt-2" variant="outline" color="danger" size="sm" v-if="!leader.id " @click="remove_member(response.data.id, item.uuid)">Remove as Member</CButton>
          <CButton block class="mt-2" variant="outline" color="danger" size="sm" v-else-if="!icare_core_team_id.includes(item.uuid) && item.uuid != leader.id " @click="remove_member(response.data.id, item.uuid)">Remove as Member</CButton>
         </CCol>
          </CRow>
        </CListGroupItem>        
      </CListGroup>
    </CCard>
    </CCol>
  </CRow>
  <icarenotemodal></icarenotemodal>
  <icaremeetingmodal></icaremeetingmodal>
  <modalphoto></modalphoto>
  
    <alertmodal></alertmodal>
</div>
</template>

<script>  
import axios from 'axios';
import _ from 'lodash'

import icare from '@/services/icare'
import visitor from '@/services/visitor'
import icarenotemodal from './icare_note_modal';
import icaremeetingmodal from './icare_meeting_modal';
import files from '@/services/files';

import EventBus from '@/eventBus';
import alertmodal from '@/views/alert/modal.vue';
import store from '@/store.js'

import modalphoto from './icare_modal_photo.vue';

export default {
name: 'detailmodal',
components: { alertmodal,icarenotemodal,icaremeetingmodal,modalphoto },
  data () {
    return {
      cardCollapse: false,
      cardCollapse1: false,
      mode: '', 
      member_id:'',
      response:[],
      accordion: '',
      form:{
        uuid:''
      },
      leader: {
        id: '',
        firstname: '',
        lastname: '',
        get_photo:[],
      },
      icare_core_team:[]  ,
      icare_core_team_id:[],
      
      temp: {},
      }
  },
  mounted(){
    this.load()
    EventBus.$on('TABLE_UPDATE', (data) => {
      if(data){
          this.load();
          console.log('load mounted')  
      }
    });
  },
  computed: {

  },
 methods:{
   load(){
     var self = this;
     icare.getIcareDetails(this.$route.query.Pud)
      .then(res => {
      this.response = res
      this.leader.id = res.data.leader != null ? res.data.leader.uuid : ''
      this.leader.firstname = res.data.leader != null ? res.data.leader.firstname : ''
      this.leader.lastname = res.data.leader != null ? res.data.leader.lastname : ''
      this.leader.get_photo = res.data.leader != null ? res.data.leader.get_photo : ''
      //this.icare_core_team.member_id = res.data.icare_core_team != null ? res.data.icare_core_team.member_id : ''
      this.icare_core_team = res.data.icare_core_team

      this.icare_core_team_id = []
      for (let i=0; i <= this.icare_core_team.length-1; i++){
        this.icare_core_team_id.push(this.icare_core_team[i].member.uuid)
      }
      console.log("load")      
      console.log(this.icare_core_team_id)
      console.log("endload")   

      

       })
        
   
      // visitor.getVisitorbyID(this.$route.query.Pud)
      // .then(res => {
      // this.response = res
      // this.visitor.id = res.data.visitor != null ? res.data.visitor.uuid : ''
      // this.visitor.firstname = res.data.visitor != null ? res.data.visitor.firstname : ''
      // this.visitor.lastname = res.data.visitor != null ? res.data.visitor.lastname : ''
      // })
    },
    show_member: function(uuid){ 

      //muncul detail at same page, tetapi saat back hanya url nya yg kerubah.
      // this.$router.push({path: '/member/member_detail',query: {Pud:uuid} }) 
      // window.location.reload()

      //new tab
      let routeData = this.$router.resolve({path: '/member/member_detail',query: {Pud:uuid} }) 
      window.open(routeData.href, '_blank');

    },
    getPhoto(data){
        if (data){
          return axios.defaults.baseURL + '/getfile/' + data.path + '/' + data.filename
        }else{
          return axios.defaults.baseURL + '/getfile/memberphoto/no_photo.jpg'
        }
      },

    openShowPhoto(url){

      window.open(url, '_blank', "height=800,width=1000");   
    },

    openModalPhoto(id){
        var params = {title: 'Icare Image', mode:'edit', data:id}
        EventBus.$emit('OPEN_MODAL_ICARE_PHOTO', params)
        console.log('load modal photo')      
    },

      assign_leader(id,member_id){
        
      //SET PERMISSION EACH FEATURE
      let Permission = store.state.user.authenticated.permission
      if (typeof Permission != 'undefined') {
        if(Permission.indexOf('Create/edit iCare (including edit leader & core team)') !== -1){
          //IF ALLOW
        if(confirm("Do you really want to assign as leader?")){
          var param = {
            member_id: member_id,
          }
          icare.assign_leader_Icare(id, param)
          .then(res => {
            this.load()
            var params = {title: 'Success', mode:'success', data:res.message}
            EventBus.$emit('OPEN_MODAL_ALERT', params)
          }).catch ((err) => {
            var params = {title: 'Error', mode:'danger', data:err.response.data.message}
            EventBus.$emit('OPEN_MODAL_ALERT', params)
          })
           //END ALLOW
          }
        } 
        else{
          //IF NOT
          var params = {title: 'Error', mode:'danger', data:'unautenticated'}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
          console.log(' open modal edit')
      }
      //SET END
        }
      },
      remove_leader(id,member_id){
      //SET PERMISSION EACH FEATURE
      let Permission = store.state.user.authenticated.permission
      if (typeof Permission != 'undefined') {
        if(Permission.indexOf('Create/edit iCare (including edit leader & core team)') !== -1){
          //IF ALLOW
        if(confirm("Do you really want to remove as leader?")){
          var param = {
            member_id: member_id,
          }
          icare.remove_leader_Icare(id, param)
          .then(res => {
            this.load()
            var params = {title: 'Success', mode:'success', data:res.message}
            EventBus.$emit('OPEN_MODAL_ALERT', params)
          }).catch ((err) => {
            var params = {title: 'Error', mode:'danger', data:err.response.data.message}
            EventBus.$emit('OPEN_MODAL_ALERT', params)
          }) 
        }
        //END ALLOW
        }
        } 
        else{
          //IF NOT
          var params = {title: 'Error', mode:'danger', data:'unautenticated'}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
          console.log(' open modal edit')
      }
      //SET END
      },
      assign_core_team(id,member_id){
        
      //SET PERMISSION EACH FEATURE
      let Permission = store.state.user.authenticated.permission
      if (typeof Permission != 'undefined') {
        if(Permission.indexOf('Create/edit iCare (including edit leader & core team)') !== -1){
          //IF ALLOW
        if(confirm("Do you really want to assign as core team?")){
          var param = {
            member_id: member_id,
          }
          icare.assign_core_team_Icare(id, param)
          .then(res => {
            this.load()
            var params = {title: 'Success', mode:'success', data:res.message}
            EventBus.$emit('OPEN_MODAL_ALERT', params)
          }).catch ((err) => {
            var params = {title: 'Error', mode:'danger', data:err.response.data.message}
            EventBus.$emit('OPEN_MODAL_ALERT', params)
          })
           //END ALLOW
        }
        } 
        else{
          //IF NOT
          var params = {title: 'Error', mode:'danger', data:'unautenticated'}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
          console.log(' open modal edit')
      }
      //SET END
        }
      },
      remove_core_team(id,member_id){
        
      //SET PERMISSION EACH FEATURE
      let Permission = store.state.user.authenticated.permission
      if (typeof Permission != 'undefined') {
        if(Permission.indexOf('Create/edit iCare (including edit leader & core team)') !== -1){
          //IF ALLOW
        if(confirm("Do you really want to remove as core team?")){
          var param = {
            member_id: member_id,
          }
          icare.remove_core_team_Icare(id, param)
          .then(res => {
            this.load()
            var params = {title: 'Success', mode:'success', data:res.message}
            EventBus.$emit('OPEN_MODAL_ALERT', params)
          }).catch ((err) => {
            var params = {title: 'Error', mode:'danger', data:err.response.data.message}
            EventBus.$emit('OPEN_MODAL_ALERT', params)
          })
           
        }
        //END ALLOW
        }
        }
        else{
          //IF NOT
          var params = {title: 'Error', mode:'danger', data:'unautenticated'}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
          console.log(' open modal edit') 
      }
      //SET END
      },
      remove_member(id,member_id){
      //SET PERMISSION EACH FEATURE
      let Permission = store.state.user.authenticated.permission
      if (typeof Permission != 'undefined') {
        if(Permission.indexOf('Create/edit iCare (including edit leader & core team)') !== -1){
          //IF ALLOW
        if(confirm("Do you really want to remove as member?")){
          var param = {
            member_id: member_id,
          }
          icare.remove_member_Icare(id, param)
          .then(res => {
            this.load()
            var params = {title: 'Success', mode:'success', data:res.message}
            EventBus.$emit('OPEN_MODAL_ALERT', params)
          }).catch ((err) => {
            var params = {title: 'Error', mode:'danger', data:err.response.data.message}
            EventBus.$emit('OPEN_MODAL_ALERT', params)
          })
        }
          //END ALLOW
        }
        } 
        else{
          //IF NOT
          var params = {title: 'Error', mode:'danger', data:'unautenticated'}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
          console.log(' open modal edit')
      }
      //SET END
      },
      
    openModalNewNote() {
      //SET PERMISSION EACH FEATURE
      let Permission = store.state.user.authenticated.permission
      if (typeof Permission != 'undefined') {
        if(Permission.indexOf('Create/edit iCare note') !== -1){
          //IF ALLOW
        var params = {title: 'New Icare Note', mode:'create', }
        EventBus.$emit('OPEN_MODAL_ICARE_NOTE', params)
        //END ALLOW
        }
        } 
        else{
          //IF NOT
          var params = {title: 'Error', mode:'danger', data:'unautenticated'}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
          console.log(' open modal edit')
      }
      //SET END
        console.log('load new note')
     
    },

    openModalEditNote(id){
      //SET PERMISSION EACH FEATURE
      let Permission = store.state.user.authenticated.permission
      if (typeof Permission != 'undefined') {
        if(Permission.indexOf('Create/edit iCare note') !== -1){
          //IF ALLOW
        var params = {title: 'Edit iCare Note', mode:'edit', data:id}
        EventBus.$emit('OPEN_MODAL_ICARE_NOTE', params)
        //END ALLOW
        }
      }
      else{
          //IF NOT
          var params = {title: 'Error', mode:'danger', data:'unautenticated'}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
          console.log(' open modal edit')
        } 
      //SET END
        console.log('load edit note')
    },

    destroyNote(id){
      //SET PERMISSION EACH FEATURE
      let Permission = store.state.user.authenticated.permission
      if (typeof Permission != 'undefined') {
        if(Permission.indexOf('Delete iCare note') !== -1){
          //IF ALLOW
      if(confirm("Do you really want to delete this note?")){
        icare.deleteIcareNote(id)
        .then(res => {
          EventBus.$emit('TABLE_UPDATE', true)
          var params = {title: 'Success', mode:'success', data:res.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        }).catch ((err) => {
          var params = {title: 'Error', mode:'danger', data:err.response.data.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
          
          console.log('load delete note')
        })
        //END ALLOW
        }
      }
      else{
          //IF NOT
          var params = {title: 'Error', mode:'danger', data:'unautenticated'}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
          console.log(' open modal edit')
        } 
      //SET END
      } 
    },

     openModalMeeting() {
      //SET PERMISSION EACH FEATURE
      let Permission = store.state.user.authenticated.permission
      if (typeof Permission != 'undefined') {
        if(Permission.indexOf('Create/edit iCare meeting schedule') !== -1){
          //IF ALLOW
      var params = {title: 'Add New iCare Meeting', mode:'create'}
      EventBus.$emit('OPEN_MODAL_ICARE_MEETING', params)
       //END ALLOW
        }
        } 
        else{
          //IF NOT
          var params = {title: 'Error', mode:'danger', data:'unautenticated'}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
          console.log(' open modal edit')
      }
      //SET END
    },

     openModalEditMeeting(id){
      //SET PERMISSION EACH FEATURE
      
      let Permission = store.state.user.authenticated.permission
      if (typeof Permission != 'undefined') {
        if(Permission.indexOf('Create/edit iCare meeting schedule') !== -1){
          //IF ALLOW
          
        var params = {title: 'Edit iCare meeting', mode:'edit', data:id}
        EventBus.$emit('OPEN_MODAL_ICARE_MEETING', params)
        //END ALLOW
        }
        } 
        else{
          //IF NOT
          var params = {title: 'Error', mode:'danger', data:'unautenticated'}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
          console.log(' open modal edit')
      }
      //SET END
        console.log('load edit note')
    },

    destroyMeeting(id){
      //SET PERMISSION EACH FEATURE
      let Permission = store.state.user.authenticated.permission
      if (typeof Permission != 'undefined') {
        if(Permission.indexOf('Delete iCare meeting schedule') !== -1){
          //IF ALLOW
      if(confirm("Do you really want to delete this meeting?")){
        icare.deleteIcareMeeting(id)
        .then(res => {
          EventBus.$emit('TABLE_UPDATE', true)
          var params = {title: 'Success', mode:'success', data:res.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        }).catch ((err) => {
          var params = {title: 'Error', mode:'danger', data:err.response.data.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
          
          console.log('load delete note')
        })
        //END ALLOW
        }
        } 
        else{
          //IF NOT
          var params = {title: 'Error', mode:'danger', data:'unautenticated'}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
          console.log(' open modal edit')
      }
      //SET END
      } 
    },
     checkCore: function () {
      
    },
    
  }  
}

</script>
